import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ProjectInfoContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading : 1,
            showModal: false, // 👈 for popup
            selectedImage: null, // 👈 to store clicked image
        }
        

    }

    // 👇 Open popup
    handleImageClick = (image) => {
        this.setState({ showModal: true, selectedImage: image });
    };

    // 👇 Close popup
    closeModal = () => {
        this.setState({ showModal: false, selectedImage: null });
    };

    componentDidMount()
    {
         this.setState({loading:0});

         const script = document.createElement("script");
         script.src   = base_url+"assets/js/loadSlider.js";  
         script.async = true;
         document.body.appendChild(script);

         script.onload = () => {
         if (window.loadSlider ) {
         window.loadProjectGallery();
         this.setState({loading:0})
         }
        };
        
    }
     
    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>

             <div class="section-full p-t80 ">
            
			 
            	<div class="container woo-entry">
                
                	<div class="row m-b30">
                    
                        <div class="col-lg-6 col-md-8 m-b10">
                            <div class="wt-box wt-product-gallery on-show-slider"> 
                            
                                <div id="sync1" class="owl-carousel owl-theme owl-btn-vertical-center m-b5">
                                    <div class="item">
                                        <div class="mfp-gallery">
                                            <div class="wt-box">
                                                <div class="wt-thum-bx wt-img-overlay1 ">
                                                    <img src={this.props.project.image} alt="" />
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    
                                    
                                </div>
                                
                                <div id="sync2" class="owl-carousel owl-theme">
                                    <div class="item">
                                        <div class="wt-media">
                                            <img src={this.props.project.image} alt="" />
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-6 col-md-12">
                            <div class="wt-post-title ">
                                <h2 class="m-tb10" style={{color:"#f05c28"}}>{this.props.project.title}</h2>
                            </div>
                           
                            
                            <table class="table table-bordered" >
                                <tbody>
                                        <tr>
                                        <td>Project Title </td>
                                        <td>{this.props.project.project_name}</td>
                                        </tr>
                                        <tr>
                                        <td>Consultant</td>
                                        <td>{this.props.project.client}</td>
                                        </tr>
                                        <tr>
                                        <td>Location</td>
                                        <td>{this.props.project.material}</td>
                                        </tr>
                                        <tr>
                                        <td>Contractor / Client:</td>
                                        <td>{this.props.project.mep_contractor}</td>
                                        </tr> 
                                </tbody>
                                 
                                
                            </table>
                           
                        </div>

                    </div>
                    
                  
                    
                    
                    
                    
				</div>
                
				 	
                	
			</div>

             <div class="section-full  p-b50">
                            <div class="container">
                            
                                
                                
                              {this.props.project.gallery_images &&  
                                
                                <div class="portfolio-wrap mfp-gallery no-col-gap row">
                                { this.props.project.gallery_images.map((gal, index) => (
                                    <div class="masonry-item cat-1 col-lg-4 col-md-4 col-sm-6 col-xs-6">
                                        <div class="wt-gallery-bx p-a15">
                                            <div class="wt-thum-bx wt-img-overlay5 wt-img-effect blurr">
                                                <a  style={{ cursor: 'pointer' }}
                      onClick={() => this.handleImageClick(gal)} >
                                                    <img src={gal}  alt="" />
                                                </a>
                                                <div class="overlay-bx">
                                                    <div class="overlay-icon">
                                                        
                                                        <Link style={{ cursor: 'pointer' }}
                      onClick={() => this.handleImageClick(gal)} class="mfp-link">
                                                            <i class="fa fa-arrows-alt wt-icon-box-xs"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                                 
                                     ))}
                            </div>
    }
                        </div>
                         
                      
                                
                            </div>
                {/* 👇 Popup modal */}
        {this.state.showModal && (
          <div className="modal-overlay" onClick={this.closeModal}>
            <div
              className="modal-content div-modal-content" 
              onClick={(e) => e.stopPropagation()} // prevent close on content click
            >
              <span className="close-btn" onClick={this.closeModal}>
                &times;
              </span>
              <img
                src={this.state.selectedImage}
                alt="Certificate"
                className="modal-image"
              />
            </div>
          </div>
        )}
             
        </div>
       

    );
 
    }
}

export default ProjectInfoContent;